<template>
    <div class="google-map-area section" id="support">
        <GmapMap
            :center="{lat:47.533710, lng:-122.357080}"
            :zoom="12"
            map-type-id="roadmap"
        >
        </GmapMap>
    </div>
</template>

<script>
    import Vue from 'vue';
    import * as VueGoogleMaps from 'vue2-google-maps'
    Vue.use(VueGoogleMaps, {
        load: {
            key: 'AIzaSyDBkn5RoHaEPVkWJjRLHc-XzBCXBN_DuRs',
            libraries: "places",
            origin: {placeId: "ChIJN1t_tDeuEmsRUsoyG83frY4"}
        },

    })
    export default {
        name: 'GoogleMap',
    }
</script>
